<template>
  <div class="custom-loading">
    <svg class="circular" viewBox="-10, -10, 50, 50">
      <path class="path" d="
        M 30 15
        L 28 17
        M 25.61 25.61
        A 15 15, 0, 0, 1, 15 30
        A 15 15, 0, 1, 1, 27.99 7.5
        L 15 15
      " :style="{ strokeWidth: '4px', fill: 'rgba(0, 0, 0, 0)', stroke: color }" />
    </svg>
  </div>
</template>

<script>
export default {
  name: "LoadingSvg",
  props: {
    color: {
      type: String,
      default: "#fff"
    }
  },
  data() {
    return {};
  },
  mounted() {

  },
  methods: {
    handleClick(event) {
      if (this.disabled) {
        event.preventDefault();
        event.stopPropagation();
        return;
      }

      this.$emit("click");
    }
  }
};
</script>

<style lang="scss" scoped>
@import "./index.scss";
</style>
